(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["email-signup-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const popup = document.querySelector('[id^="EmailSignupPopup-"]');
    if (!popup || !window.localStorage) return;

    const storageKey = 'yv_email_popup_closed_at';
    const subscribedKey = 'yv_email_popup_subscribed';
    const delay = Number(popup.dataset.delay || 4000);
    const frequencyDays = Number(popup.dataset.frequency || 7);
    const now = Date.now();
    const lastClosed = Number(localStorage.getItem(storageKey) || 0);
    const alreadySubscribed = localStorage.getItem(subscribedKey) === 'true';
    const recentlyClosed = lastClosed && now - lastClosed < frequencyDays * 24 * 60 * 60 * 1000;
    const submittedNewsletter = window.location.search.includes('customer_posted=true');

    if (submittedNewsletter) {
      localStorage.setItem(subscribedKey, 'true');
      return;
    }

    if (alreadySubscribed || recentlyClosed) return;

    const closePopup = () => {
      localStorage.setItem(storageKey, String(Date.now()));
      popup.close();
    };

    popup.querySelectorAll('[data-popup-close]').forEach((button) => {
      button.addEventListener('click', closePopup);
    });

    popup.addEventListener('click', (event) => {
      if (event.target === popup) closePopup();
    });

    popup.addEventListener('close', () => {
      if (!localStorage.getItem(storageKey)) {
        localStorage.setItem(storageKey, String(Date.now()));
      }
    });

    const form = popup.querySelector('form');
    if (form) {
      form.addEventListener('submit', () => {
        localStorage.setItem(subscribedKey, 'true');
      });
    }

    window.setTimeout(() => {
      if (typeof popup.showModal === 'function') {
        popup.showModal();
      } else {
        popup.setAttribute('open', '');
      }
    }, delay);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
